import getAnswer from "./getAnswer";

export default (variable, value, answers) => {
    return getAnswer(variable, value, answers) !== null;
};